<template src="./ConsignmentDetails/ConsignmentDetails.html"></template>
<script>
import ImageGallery from '@/widgets/ImageGallery'
import estateTypeLabels from '@/utils/estate-type-labels'

export default {
    name: 'ConsignmentDetails',
    components: {
        ImageGallery,
    },
    props: {
        consignment: Object,
    },
    data: () => ({
        openImageGallery: false,
        imageGalleryTitle: '',
        imageGalleryImages: [],
    }),
    computed: {
        estateType() {
            return estateTypeLabels[this.$props.consignment.address.settings.estateType]
        },
    },
    methods: {
        onGalleryClose() {
            this.openImageGallery = false
        },
        onPhotosOpen() {
            this.openImageGallery = true
            this.imageGalleryTitle = 'Photos'
            this.imageGalleryImages = this.consignment.images.map((image) => image.url)
        },
    },
}
</script>
<style lang="scss" scoped>
.card {
    margin-bottom: 10px;
}

.task-dashboard {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    border-left: solid 0px slategrey;
}

.dashboard-row {
    display: flex;
    width: 100%;
}

.dashboard-row-single {
    margin-right: 10px;
}

.dashboard-row-child {
    flex: 1;
    margin-right: 10px;
}

.special-instructions-content {
    padding: 15px;
    font-size: 12px;
}
</style>
